import { render, staticRenderFns } from "./base_equipments.vue?vue&type=template&id=0b02357e&scoped=true&"
import script from "./base_equipments.vue?vue&type=script&lang=js&"
export * from "./base_equipments.vue?vue&type=script&lang=js&"
import style0 from "./base_equipments.vue?vue&type=style&index=0&id=0b02357e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b02357e",
  null
  
)

export default component.exports